export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";

export const SAVE_USER_ACTION = "SAVE_USER_ACTION";
export const SAVE_USER_ACTION_FAIL = "SAVE_USER_ACTION_FAIL";

export const CANDIDATE_LOGIN_ACTION = "CANDIDATE_LOGIN_ACTION";
export const CANDIDATE_LOGIN_ACTION_FAIL = "CANDIDATE_LOGIN_ACTION_FAIL";

export const USER_ACTIVITY_ACTION = "USER_ACTIVITY_ACTION";

export const USER_ACTIVITY_ACTION_FAIL = "USER_ACTIVITY_ACTION_FAIL";
export const SETTINGS_USER_UPDATED = "SETTINGS_USER_UPDATED";
